module.exports = {
  PORT: "3124",
  NODE_ENV: "development",

  SERVER_DEV_URL: "http://localhost:3123",
  SERVER_STAGING_URL: "https://smartscoregolf-api.cloudxier.dev",
  SERVER_PROD_URL: "",

  CLIENT_DEV_HOST: "localhost",
  CLIENT_STAGING_HOST: "smartscoregolf.cloudxier.dev",
  CLIENT_PROD_HOST: "",

  CLIENT_DEV_URL: "http://localhost:3000",
  CLIENT_STAGING_URL: "https://smartscoregolf.cloudxier.dev",
  CLIENT_PROD_URL: "",

  MAIN_WEBSITE_TITLE: 'SMARTSCORE | ',
  SITE_NAME: 'SMARTSCORE Digital Cup Version 2.0'
}
